export default __webpack_public_path__ + "media/zurb/img/icons/favicon/mstile-144x144-d7ed28b4727967fb7fd20ab29b5d674c.png";